<template>
    <div class="p-4 flex flex-col items-center">
        <div class="w-full flex justify-end" v-if="meta.info.hasValidSignature">
            <SoundToggleButton v-model="isSoundOn" />
        </div>
        <div class="font-semibold text-xl inline-block">
            {{ smileyPollQuestion.question }}
        </div>
        <div class="mt-5" v-if="meta.info.hasValidSignature">
            <div class="flex gap-2 md:gap-4">
                <div>
                    <button type="button" @click="vote('option_1')">
                        <SmileyPollEmojiImage :number="1" />
                    </button>
                    <div class="text-center" v-if="false">{{ form.option_1 }}</div>
                    <div class="text-center" v-if="false">{{ total.option_1 }}</div>
                </div>
                <div>
                    <button type="button" @click="vote('option_2')">
                        <SmileyPollEmojiImage :number="2" />
                    </button>
                    <div class="text-center" v-if="false">{{ form.option_2 }}</div>
                    <div class="text-center" v-if="false">{{ total.option_2 }}</div>
                </div>
                <div>
                    <button type="button" @click="vote('option_3')">
                        <SmileyPollEmojiImage :number="3" />
                    </button>
                    <div class="text-center" v-if="false">{{ form.option_3 }}</div>
                    <div class="text-center" v-if="false">{{ total.option_3 }}</div>
                </div>
                <div>
                    <button type="button" @click="vote('option_4')">
                        <SmileyPollEmojiImage :number="4" />
                    </button>
                    <div class="text-center" v-if="false">{{ form.option_4 }}</div>
                    <div class="text-center" v-if="false">{{ total.option_4 }}</div>
                </div>
            </div>
            <div class="mt-5 flex justify-center">
                <div :style="`opacity: ${opacity}%`" class="text-xl text-gray-600 font-semibold">
                    {{ $t('messages.thanks!') }}
                </div>
            </div>
        </div>
        <div v-else>{{ $t('messages.poll_is_closed') }}</div>
    </div>
</template>

<script>
import SmileyPollLayout from '@/Shared/SmileyPollLayout.vue';
import SmileyPollEmojiImage from '@/components/SmileyPollEmojiImage.vue';
import { debounce } from 'lodash';
import axios from 'axios';
import { Howl } from 'howler';
import SoundToggleButton from '@/components/SoundToggleButton.vue';

export default {
    components: {
        SoundToggleButton,
        SmileyPollEmojiImage,
    },
    layout: SmileyPollLayout,
    name: 'Edit',
    props: ['meta', 'smileyPollResult', 'smileyPollQuestion'],
    data() {
        return {
            form: {
                option_1: 0,
                option_2: 0,
                option_3: 0,
                option_4: 0,
            },
            total: {
                option_1: 0,
                option_2: 0,
                option_3: 0,
                option_4: 0,
            },
            opacity: 0,
            isSoundOn: true,
        };
    },
    watch: {
        opacity: function (value) {
            if (value > 0) {
                setTimeout(() => (this.opacity -= 10), 100);
            }
        },
    },
    methods: {
        vote(option) {
            this.form[option]++;
            this.submit();
            this.opacity = 100;
            this.playSound();
        },
        playSound() {
            if (this.isSoundOn) {
                const sound = new Howl({
                    src: ['/assets/gamification/currency/bubble_pop.mp3'],
                });
                sound.play();
            }
        },
        submit: debounce(function () {
            const buffer = {
                option_1: this.form.option_1,
                option_2: this.form.option_2,
                option_3: this.form.option_3,
                option_4: this.form.option_4,
            };

            this.total.option_1 += this.form.option_1;
            this.total.option_2 += this.form.option_2;
            this.total.option_3 += this.form.option_3;
            this.total.option_4 += this.form.option_4;

            this.form.option_1 = 0;
            this.form.option_2 = 0;
            this.form.option_3 = 0;
            this.form.option_4 = 0;

            axios.patch(this.meta.links.update, buffer);
        }, 3000),
    },
};
</script>
